module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABaklEQVRIS92WwVHDQAxFvy65khJCBYQO6IB0AB0Qbtm9sLlocwM6gA5MB3RA6CAlmGsun5HHngnOjvGaDBnYo0fapy/91VjwS0dSnMViMRGRexGZ5dRBsiB5u1qtNu28JMg5NzdQDqSJNVCM8aEXyHsfANwNAQFYqqrlfzlJRUcBkfwQkb1W7JZL0lp9Un8bpojkc4zxuquNzrknEbn6EWjAnIYp+pug+t2YnceqKi3Xvahq58P13hcALndn5L0ngJLk0t5VZW/nXNm4JgEqAXS6DsDcikyAQHITYzytQDW9ikuAcsdUmaF953FBh9h1vRTV27sQkbOcvpF8Jzmz7f0tCMC5qq5zAO1Y7/0UwFvz3ea+NyNzCQBTY27LPiTNfTMRmXSCsm/ukZBU1CMvO+Qfg5xz61wr9+2fWT7GOG1cZ7vspm9yZtyjqs4rUAhhvN1uA8mLQykzJSLyOhqNQgihTP6cZFbcK/wTLSbyG1/h4McAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_print7a.png
// module id = 72Qs
// module chunks = 1